const useGetBrowserLanguage = () => {
  const isBrowser = typeof window !== "undefined"

  let language = "en"

  return language
}

export default useGetBrowserLanguage